import { useEffect, useMemo, useState } from 'react'

const useSelectedProducts = ({ products }) => {
  const [selectedProducts, setSelectedProducts] = useState([])

  const productsKey = useMemo(() => products?.map(product => product.id).join(','), [products])

  useEffect(() => {
    setSelectedProducts([])
  }, [productsKey])

  const onCheckProduct = (e, id) => {
    if (e.target.checked) {
      setSelectedProducts(prev => [...prev, id])
    } else {
      setSelectedProducts(prev => prev.filter(productId => productId !== id))
    }
  }

  const onCheckAllProducts = e => {
    if (e.target.checked) {
      setSelectedProducts(products?.map(product => product.id) || [])
    } else {
      setSelectedProducts([])
    }
  }

  return {
    selectedProducts,
    setSelectedProducts,
    onCheckProduct,
    onCheckAllProducts,
  }
}

export default useSelectedProducts
